const registrationReq = {
  pageTitle: "Registration Requests",
  reject: "Reject",
  listBreadcrumb: "Registration Requests",
  searchPlaceholder: "Search Companies",
  companiesBreadcrumb: "Companies",
  pendingTab: "Pending",
  rejectedTab: "Rejected",
  company: "Company",
  companyNameEn: "Company name (EN)",
  companyNameAr: "Company name (AR)",
  commercialRecord: "Commercial Record",
  requestedDate: "Requested Date",
  creationDate: "Creation Date",
  rejectModalTitle: "Reject Registration Request",
  rejectModalDescription:
    "Please provide a reason for rejecting {name}. This will be sent to the company via email.",
  rejectionReasonLabel: "Rejection Reason",
  required: "Required",
  rejectionReasonMinLength: "Please enter at least 3 characters.",
  rejectionReasonPlaceholder: "Enter the reason for rejection...",
  confirmRejection: "Confirm Rejection",
  emptyPendingTitle: "No pending registration requests",
  emptyRejectedTitle: "No rejected registration requests",
  noDataDescription: "No pending registration requests found.",

  backToRegistrationRequests: "Back to Registration Requests",
  companyOverallSatisfaction: "Overall Company Satisfaction",
  companySatisfactionPeriod: "All time",
  companyInformation: "Company information",
  contactPerson: "Contact person",
  documents: "Documents",
  pdfPreview: "PDF preview",
  documentViewer: "Document Viewer",
  viewerPageOf: "of",
  viewerPreviousPage: "Previous page",
  viewerNextPage: "Next page",
  viewerUnsupportedWord:
    "Preview isn’t available for Word documents in the browser. Download the file to open it.",
  previewPdfHint: "Click “Preview” on any document to preview it here.",
  closeViewer: "Close Viewer",
  preview: "Preview",
  download: "Download",
  englishName: "English name",
  arabicName: "Arabic name",
  city: "City",
  fullName: "Full name",
  mobileNumber: "Mobile number",
  emailAddress: "Email address",
  approveRegistration: "Approve registration",
  rejectRegistration: "Reject registration",
  statusPendingApproval: "Pending approval",
  statusApproved: "Approved",
  statusRejected: "Rejected",
  companyDetailsLoadError: "We could not load this company. Please try again.",
  retry: "Retry",
  commercialRecordDocument: "Commercial record",
  delegationDocument: "Delegation letter",
  idDocument: "ID document",
};

export default registrationReq;
